import React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import classnames from 'classnames'
import styled from 'styled-components'
import shortid from 'shortid'
import {
  CustomInput,
  FormGroup,
  Label,
  Input,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Container,
  Row,
  Col,
} from 'reactstrap'
import moment from '../../lib/moment.js'
import { status, url, counting } from '../../constants'

class LeaveTypeForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: '1',
    }
  }
  render() {
    return (
      /* eslint no-underscore-dangle: 0 */
      <Background>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={ classnames({ active: this.state.activeTab === '1' }) }
              onClick={ () => {} }
            >
              Leave Type Information
            </NavLink>
          </NavItem>
          <Image
            src={ url }
            onClick={ get(this.props, 'create') ? this.props.cancelForm : this.props.showDiscard }
          />
        </Nav>
        <TabContent activeTab={ this.state.activeTab } >
          <TabPane tabId="1">
            <Row>
              <Col sm="12">
                <TypeForm onSubmit={ (e) => e.preventDefault() }>
                  <FormGroup>
                    <Container >
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Start Date</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <InputFieldDate
                            autoComplete='off'
                            name="start_date"
                            type="date"
                            disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                            value={ moment(get(this.props, 'start_date')).format('YYYY-MM-DD') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >End Date</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <InputFieldDate
                            autoComplete='off'
                            name="end_date"
                            type="date"
                            disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                            value={ moment(get(this.props, 'end_date')).format('YYYY-MM-DD') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Leave Type ID</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <InputField
                            name="leave_type_code"
                            disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                            placeholder="Enter Leave Type ID"
                            value={ get(this.props, 'leave_type_code') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Leave Type Name</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <InputField
                            name="name"
                            disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                            placeholder="Enter Leave Type Name"
                            value={ get(this.props, 'name') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }><Label>Counting</Label></Col>
                        <Col sm={ 9 }>
                          <CustomInputField
                            type="select"
                            id="is_calendar_day"
                            name="is_calendar_day"
                            disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                            value={ get(this.props, 'is_calendar_day') }
                            onChange={ this.props.handleInput }
                          >
                            {
                              counting.map((s) => <option key={ shortid() } value={ s.value }>{ s.label }</option>)
                            }
                          </CustomInputField>
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }><Label>Conditions</Label></Col>
                        <Col sm={ 9 }>
                          <CustomInput
                            type="checkbox"
                            name="is_probation_pass"
                            id="is_probation_pass"
                            label="Passed Probation"
                            disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                            checked={ get(this.props, 'is_probation_pass') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }><Label /></Col>
                        <Col sm={ 9 }>
                          <CustomInput
                            type="checkbox"
                            name="is_hr_approve"
                            id="is_hr_approve"
                            label="Approval by HR"
                            disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                            checked={ get(this.props, 'is_hr_approve') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }><Label /></Col>
                        <Col sm={ 9 }>
                          <CustomInput
                            type="checkbox"
                            name="is_attachment"
                            id="is_attachment"
                            label="Attach document needed"
                            disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                            checked={ get(this.props, 'is_attachment') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }><Label /></Col>
                        <Col sm={ 9 }>
                          <CustomInput
                            type="checkbox"
                            name="is_once"
                            id="is_once"
                            label="Only one time leave"
                            disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                            checked={ get(this.props, 'is_once') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }><Label /></Col>
                        <Col sm={ 9 }>
                          <CustomInput
                            type="checkbox"
                            name="is_two_year_service_require"
                            id="is_two_year_service_require"
                            label="Require more than 2 Year of Services"
                            disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                            checked={ get(this.props, 'is_two_year_service_require') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }><Label /></Col>
                        <Col sm={ 4 }>
                          <CustomInput
                            type="checkbox"
                            name="is_maximum_days"
                            id="is_maximum_days"
                            label="Maximum Days"
                            disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                            checked={ get(this.props, 'is_maximum_days') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                        <Col sm={ 2 }>
                          <InputField
                            name="max_days"
                            id="max_days"
                            label="Maximum Days"
                            invalid={ get(this.props, 'is_maximum_days') && get(this.props, 'max_days') === '' }
                            disabled={ (!get(this.props, 'isEdit') &&
                            get(this.props, 'create') === undefined) ||
                            !get(this.props, 'is_maximum_days') }
                            value={ get(this.props, 'max_days') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }><Label /></Col>
                        <Col sm={ 4 }>
                          <CustomInput
                            type="checkbox"
                            name="is_male"
                            id="is_male"
                            label="Male"
                            disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                            checked={ get(this.props, 'is_male') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                        <Col sm={ 4 }>
                          <CustomInput
                            type="checkbox"
                            name="is_female"
                            id="is_female"
                            label="Female"
                            disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                            checked={ get(this.props, 'is_female') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }><Label /></Col>
                        <Col sm={ 9 }>
                          <CustomInput
                            type="checkbox"
                            name="is_deduct_leave_entitlment"
                            id="is_deduct_leave_entitlment"
                            label="Deduct Leave Entitlement"
                            disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                            checked={ get(this.props, 'is_deduct_leave_entitlment') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      {/* <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Sequence</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <InputField
                            name="name"
                            disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                            placeholder="Enter Leave Entitlement Name"
                            value={ get(this.props, 'name') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row> */}
                      {
                        get(this.props, 'create') === undefined &&
                        <Row style={ { marginTop: 10 } }>
                          <Col sm={ 3 }><Label>Status</Label></Col>
                          <Col sm={ 9 }>
                            <CustomInputField
                              type="select"
                              id="is_active"
                              name="is_active"
                              disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                              value={ get(this.props, 'is_active') }
                              onChange={ this.props.handleInput }
                            >
                              {
                                status.map((s) => <option key={ shortid() } value={ s.value }>{ s.label }</option>)
                              }
                            </CustomInputField>
                          </Col>
                        </Row>
                      }
                      {
                        get(this.props, 'create') === undefined &&
                          <Row style={ { marginTop: 10 } }>
                            <Col sm={ 3 }><Label>Modified Date</Label></Col>
                            <Col sm={ 9 }>
                              <p>{ get(this.props, 'updated') ? moment(get(this.props, 'updated')).format('DD/MM/YYYY') : '-' }</p>
                            </Col>
                          </Row>
                      }
                      {
                        get(this.props, 'create') === undefined &&
                          <Row style={ { marginTop: 10 } }>
                            <Col sm={ 3 }><Label>Modified By</Label></Col>
                            <Col sm={ 9 }>
                              <p>{ get(this.props, 'updated_by') ? get(this.props, 'updated_by') : '-' }</p>
                            </Col>
                          </Row>
                      }
                    </Container>
                  </FormGroup>
                  <Right>
                    { get(this.props, 'button') }
                  </Right>
                </TypeForm>
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </Background>
    )
  }
}
LeaveTypeForm.propTypes = {
  handleInput: PropTypes.func.isRequired,
  cancelForm: PropTypes.func.isRequired,
  showDiscard: PropTypes.func.isRequired,
}
export default LeaveTypeForm

const TypeForm = styled.div`
  overflow-y: scroll;
  max-height: calc(100vh - 220px);
`

const Right = styled.div`
  background-color: white;
  padding: 10px;
  text-align: right;
`
const Background = styled.div`
  background-color: white;
  padding: 10px;
  font-family: 'Gotham-Bold' !important;
  font-size: 14px ;
`
const InputField = styled(Input)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height : 100% ;
    font-size: 12px ;
    ::-webkit-outer-spin-button,
    ::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
`
const InputFieldDate = styled(Input)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height : 100% ;
    font-size: 12px ;
    float: right;
    ::-webkit-inner-spin-button {
      display: none;
      -webkit-appearance: none;
    }
 `
const Image = styled.img`
width: 20px;
height: 20px;
position: absolute;
right: 10px;
`
const CustomInputField = styled(CustomInput)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height : 100% ;
    font-size: 12px ;
`



// WEBPACK FOOTER //
// ./src/components/leave-type/index.js